//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LeanCanvas from '~/components/sections/lean-canvas.vue';
export default {
  components: { LeanCanvas },
  data() {
    return {
      slug: 'lean-canvas',
      heading: 'Lean Canvas',
      description: null,
    };
  },
  async fetch() {
    const { description, name } = await this.$content(
      'pages',
      this.slug,
    ).fetch();
    this.heading = name;
    this.description = description;
  },
  fetchKey() {
    return `page/${this.slug}`;
  },
  head() {
    return {
      title: this.heading,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
    };
  },
};
